import { styled, css } from "styled-components";

export const ToolbarContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.default[200]};
  position: relative;
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.colors.default[100]};
  border-radius: 3px 3px 0 0;
  display: flex;
  justify-content: space-between;
  overflow: clip;
`;

export const Button = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  height: 36px;
  transition: background 0.2s;
  cursor: pointer;
  width: 100%;
  flex: 1;
  background: ${({ theme }) => theme.colors.default[50]};

  &:hover {
    background: ${({ theme }) => theme.colors.default[100]};
  }

  ${({ $disabled }) =>
  $disabled &&
  css`
      pointer-events: none;
    `}
`;

export const ButtonWrapper = styled.div<{ $isActive: boolean }>`
  width: 100%;
  flex: 1;

  &:not(:last-of-type) {
    border-right: 1px solid ${({ theme }) => theme.colors.default[200]};
  }

  ${({ $isActive, theme }) =>
  $isActive &&
  css`
      ${Button} {
        background: ${theme.colors.default[200]};
      }
    `}
`;

export const ButtonsContainer = styled.div`
  height: 100%;
  display: flex;
  width: 100%;
`;

export const PopupItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  > div {
    height: 36px;
    width: 36px;
    max-width: 36px;
    border-radius: 4px;
    overflow: clip;
  }
`;

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
